import { Box, styled } from '@mui/material';

export const FeatureAccessContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  height: '100%',
}));

export const ToolbarRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '16px',
  flexWrap: 'wrap',
}));

/** Wider than the search box's natural width, so longer company names fit while typing. */
export const SearchWrapper = styled(Box)(({ theme }) => ({
  width: '360px',
  maxWidth: '100%',
  '& .MuiTextField-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
  },
}));

export const FilterGroup = styled(Box)(() => ({
  display: 'flex',
  gap: '12px',
  minWidth: '360px',
}));

export const StatusText = styled('span', { shouldForwardProp: prop => prop !== 'enabled' })<{ enabled: boolean }>(
  ({ enabled }) => ({
    fontWeight: 600,
    color: enabled ? '#2E9E56' : '#9CA3AF',
  }),
);

export const PanelFeatureRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 0',
  fontSize: '14px',
  color: '#303c42',
  borderBottom: '1px solid #E5E7EB',
}));

export const PanelErrorRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'flex-start',
}));

export const FeatureAccessBody = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));
